import { Platform } from 'react-native'

import { BottomSheet } from '@zet/common/components/bottomSheet'
import { BottomView } from '@zet/common/components/bottomView'
import KeyBoardWrapper from '@zet/common/components/keyboardWrapper'
import { APP_NAME } from '@zet/end-points'
import { UserContext } from '@zet/feature-user/api/user/types'
import Constants from 'expo-constants'

export * from './errorScreens/accountBlockedScreen'
export * from './errorScreens/networkIssueScreen'
export * from './errorScreens/serverDownScreen'
export * from './updatesModule'

const getCategoryName = (id: number | string, isPlural = false) => {
  switch (id?.toString()) {
    case '15':
      return isPlural ? 'Credit Cards' : 'Credit Card'
    case '9':
      return isPlural ? 'Personal Loans' : 'Personal Loan'
    case '18':
      return isPlural ? 'Secured Cards' : 'Secured Card'
    case '10':
      return isPlural ? 'Business Loans' : 'Business Loan'
    case '11':
      return isPlural ? 'Instant Loans' : 'Instant Loan'
    case '16':
      return isPlural ? 'Pay Later/EMI Cards' : 'Pay Later/EMI Card'
    case '12':
      return 'Gold Loan'
    case '2':
      return 'Digital Gold'
    case '5':
      return isPlural ? 'Bank Accounts' : 'Bank Account'
    case '17':
      return isPlural ? 'Others' : 'Other'
    case '14':
      return 'Insurance'
    case '1':
      return 'Investment'
    case '3':
      return 'Payment Gateway'
    case '4':
      return 'Fastag'
    case '6':
      return isPlural ? 'Demat Accounts' : 'Demat Account'
    case '7':
      return 'Cryptocurrency'
    case '8':
      return 'Recharge & Bill Payment'
    default:
      return ''
  }
}

const removeExtraPincodes = (pincodes: string[]) => {
  if (pincodes.length > 5) {
    while (pincodes.length > 5) {
      pincodes.pop()
    }
  }
  return pincodes
}

const removeDuplicatesInArrayInDescendingOrder = (arr: string[]) => {
  const indexObj = {}
  for (let i = 0; i < arr.length; i++) {
    if (!(arr[i] in indexObj)) {
      indexObj[arr[i]] = i
    } else if (indexObj[arr[i]] > i) {
      indexObj[arr[i]] = i
    } else {
      arr.splice(i, 1)
      i--
    }
  }
  return arr
}

const checkForValidUrl = (url: string) => {
  const urlRegex =
    /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/
  return urlRegex.test(url)
}

const getUserDataToRegisterInAnalytics = (userData: UserContext) => {
  return {
    fullName: userData?.fullName as string,
    id: userData?.id,
    email: userData?.email,
    phoneNumber:
      userData?.phoneNumber?.length === 12
        ? userData?.phoneNumber
        : `91${userData?.phoneNumber}`,
    appVersionNo: getAppVersionNo(),
    ...(Platform.OS !== 'web' && { appOS: Platform.OS }),
    zetCode: userData?.zetCode,
  }
}

const makePointWiseSingleLine = (input: string): string => {
  if (!input) return ''
  const lines = input
    .split('\n')
    .map((l: string) => l.trim())
    .filter((l: string) => l.length > 0)

  const isNewPoint = (line: string): boolean => {
    return (
      /^\d+(?:\.\d+)*\./.test(line) ||
      /^•/.test(line) ||
      /^[A-Z][A-Z\s&\-/.]+$/.test(line)
    )
  }

  const result: string[] = []
  for (const line of lines) {
    if (result.length === 0 || isNewPoint(line)) {
      result.push(line)
    } else {
      result[result.length - 1] = `${result[result.length - 1]} ${line}`
    }
  }
  return `${result.join('\n\n')}\n`
}

const isApp = Platform.OS === 'android' || Platform.OS === 'ios'

const isIOS = Platform.OS === 'ios'

const isAndroid = Platform.OS === 'android'

const getAppVersionNo = () => {
  const { ios, android } = Constants.expoConfig?.extra?.otaVersion || {}
  const isZetApp = APP_NAME === 'zet-app'

  if (isZetApp) {
    return Platform.select({ ios, android })
  }

  return Constants.expoConfig?.version || ''
}

const hexToRgb = (hex: string) => {
  const cleanHex = hex.replace('#', '')

  const bigint = parseInt(cleanHex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return [r, g, b]
}

export {
  BottomSheet,
  BottomView,
  checkForValidUrl,
  getAppVersionNo,
  getCategoryName,
  getUserDataToRegisterInAnalytics,
  hexToRgb,
  isAndroid,
  isApp,
  isIOS,
  KeyBoardWrapper,
  makePointWiseSingleLine,
  removeDuplicatesInArrayInDescendingOrder,
  removeExtraPincodes,
}
